import { WebhookSubscriptionPayload } from 'pages/SettingsIntegrationsWebhooksPage/types';

import {
  getRequest,
  postRequest,
  patchRequest,
  deleteRequest,
} from '../../methods';

const settingsGetWebhookSubscriptions = () =>
  getRequest('connect/webhook_subscriptions');

const settingsGetWebhookSubscription = (id: number) =>
  getRequest(`connect/webhook_subscriptions/${id}`);

const settingsCreateWebhookSubscription = (
  payload: WebhookSubscriptionPayload
) =>
  postRequest('connect/webhook_subscriptions', {
    webhookSubscription: payload,
  });

const settingsUpdateWebhookSubscription = (
  id: number,
  payload: WebhookSubscriptionPayload
) =>
  patchRequest(`connect/webhook_subscriptions/${id}`, {
    webhookSubscription: payload,
  });

const settingsDeleteWebhookSubscription = (id: number) =>
  deleteRequest(`connect/webhook_subscriptions/${id}`);

const webhookSubscriptions = {
  settingsGetWebhookSubscriptions,
  settingsGetWebhookSubscription,
  settingsCreateWebhookSubscription,
  settingsUpdateWebhookSubscription,
  settingsDeleteWebhookSubscription,
};

export default webhookSubscriptions;
